import axios from "axios";
const geo = axios.create({
  baseURL: "https://maps.googleapis.com",
  headers: {
    "Content-Type": "application/json",
  },
});
geo.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const geoRequest = {
  get: (url, params) =>
    geo
      .get(url, { params })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err.response.data)),
};
//! 1
export const getProperLocation = (params) =>
  geoRequest.get("/maps/api/geocode/json", params);
